import { ServiceTypeTaskDefinitionRecord } from '~/modules/transportation/types';
import { createQueryHook } from '~/shared/providers/api';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

interface ServiceTypeTaskDefinitionsFilter {
  serviceTypeId?: string;
  serviceTypeIds?: string[];
}

interface GetServiceTypeTaskDefinitionsVariables {
  filter?: ServiceTypeTaskDefinitionsFilter;
  pagination?: {
    offset: number;
    limit: number;
  };
}

export const useServiceTypeTaskDefinitionsQuery = createQueryHook(
  'transportation.serviceTypeTaskDefinitions',
  (variables: GetServiceTypeTaskDefinitionsVariables) => ({
    serviceTypeTaskDefinitions: {
      __args: {
        filter: variables.filter,
        pagination: variables.pagination,
        sorting: ['SequenceAsc'],
      },
      page: {
        total: true,
      },
      entries: {
        id: true,
        serviceTypeId: true,
        taskType: true,
        assetRole: true,
        sequence: true,
        locationRef: true,
        allowLocationOverride: true,
        assetGroup: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (
      data,
    ): {
      taskDefinitions: ServiceTypeTaskDefinitionRecord[];
      total: number;
    } => ({
      taskDefinitions: (data?.serviceTypeTaskDefinitions?.entries ?? []).map(
        (def) => ({
          id: def.id,
          serviceTypeId: def.serviceTypeId,
          taskType: def.taskType,
          assetRole: def.assetRole ?? undefined,
          sequence: def.sequence,
          locationRef: def.locationRef ?? undefined,
          allowLocationOverride: def.allowLocationOverride ?? false,
          assetGroup: def.assetGroup ?? undefined,
          timestamps: {
            createdAt: parseZonedDateTime(def.timestamps.createdAt),
            updatedAt: parseZonedDateTime(def.timestamps.updatedAt),
          },
        }),
      ),
      total: data?.serviceTypeTaskDefinitions?.page?.total ?? 0,
    }),
  },
);
